// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__13xts","content":"styles_content__1h1dI","selectAll":"styles_selectAll__uFpBd"};